import React, { useContext, useEffect, useRef, useState } from "react";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import TableFooter from "../../components/TableFooter";
import NoSearchitems from "../../components/NoSearchitems";
import { decryptText } from "../../utils/cipherText";
import { CgArrowUp, CgArrowDown } from "react-icons/cg";
import { TbFilterX } from "react-icons/tb";
import all from "../../images/all.png";
import desc from "../../images/desc.png";
import asc from "../../images/asc.png";
import EligibleTopBar from "../../components/EligibleTopBar";
import { set } from "date-fns";
import { sideBarContext } from "../../App";

// import UserPage from "../UserPage/UserPage";

const EligibleUsers = () => {
  const navigate = useNavigate();
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const sortRef = useRef(null);
  const sortDivRef = useRef(null);

  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [userId, setUserId] = useState("");
  const [showUserDetails, setShowUserDetails] = useState();
  const [userIndex, setUserIndex] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [selectAllCheckbox, setSelectAllCheckbox] = useState(false);
  const [checkboxes, setCheckboxes] = useState(list?.map(() => false));
  const [fullScreen, setFullScreen] = useState(false);
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState();
  const [searchPages, setSearchPages] = React.useState();
  const [searchRows, setSearchRows] = React.useState();
  const [filterShow, setFilterShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("name");
  const [imageLoading, setImageLoading] = useState(false);
  const [searchEmpty, setSearchEmpty] = useState(false);

  const storedPage = parseInt(sessionStorage.getItem("currentPage"), 10) || 1;
  const storedSearch = sessionStorage.getItem("query") || "";
  const [pageNo, setPageNo] = React.useState(storedPage);
  const [searchQuery, setSearchQuery] = React.useState(storedSearch);

  const [openAdvancedFilter, setOpenAdvancedFilter] = useState(false);
  const [advancedOptionSelected, setAdvancedOptionSelected] = useState("");
  const [advancedStartDate, setAdvancedStartDate] = useState("");
  const [advancedEndDate, setAdvancedEndDate] = useState("");
  const [advancedSelectValue, setAdvancedSelectValue] = useState("");
  const [advancedEnterValue, setAdvancedEnterValue] = useState("");
  const sortStates = ["", "asc", "desc"];
  const [sortType, setSortType] = useState("");
  const [sortBy, setSortBy] = useState(sortStates[0]);
  const [sortTypeTemp, setSortTypeTemp] = useState("");
  const [openSorting, setOpenSorting] = useState(false);
  const { expanded } = useContext(sideBarContext);

  const fetchUsers = async (controller, flag) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      if (flag) {
        if (sortType && !sortBy) return;
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/v1/check_eligibility_users?page=${pageNo}&per_page=${rowsPerPage}&sort_by=${sortType}&order=${sortBy}`,
          options
        );
        setTotalPages(res.data.total_page_count);
        setTotalRows(res.data.total_records);
        setList(res.data.user_data);
      } else {
        if (sortType && !sortBy) return;
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/v1/check_eligibility_users?page=${pageNo}&per_page=${rowsPerPage}&sort_by=${sortType}&order=${sortBy}`,
          options
        );
        setTotalPages(res.data.total_page_count);
        setTotalRows(res.data.total_records);
        setList(res.data.user_data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const fetchAdvancedFilters = async () => {
    if (searchQuery) {
      const controller = new AbortController();
      fetchSearchedUsers(controller, false);
      setOpenAdvancedFilter(false);
      return;
    }
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      // signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${
          process.env.REACT_APP_URL
        }/lender/asset_index?page=${pageNo}&rows_per_page=${rowsPerPage}&page_name=asset&filter_by=${advancedOptionSelected}&start_date=${advancedStartDate}&end_date=${advancedEndDate}&asset_filter=${advancedSelectValue}&value=${advancedEnterValue}&sort_by=${
          sortBy ? sortType + sortBy : ""
        }`,
        options
      );
      setTotalPages(res.data.total_pages);
      setTotalRows(res.data.total_entries);
      setList(res.data.user_details);
      setOpenAdvancedFilter(false);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const clearAdvancedFilters = () => {
    setAdvancedOptionSelected("");
    setAdvancedStartDate("");
    setAdvancedEndDate("");
    setAdvancedSelectValue("");
    setAdvancedEnterValue("");
    setOpenAdvancedFilter(false);
    sessionStorage.removeItem("currentPage");
    const controller = new AbortController();
    if (searchQuery) {
      fetchSearchedUsers(controller, true);
      return;
    }
    fetchUsers(controller, true);
    return () => {
      controller.abort();
    };
  };

  const fetchSearchedUsers = async (controller, flag) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");

    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      if (flag) {
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/v1/check_eligibility_users?search=${searchQuery}&page=${pageNo}&rows_per_page=${rowsPerPage}&sort_by=${sortType}&order=${sortBy}`,
          options
        );
        setSearchPages(res.data.total_page_count);
        setSearchRows(res.data.total_records);
        // setList(res.data.user_details);
        if (res.data.user_data.length < 1) {
          setSearchEmpty(true);
        }
        if (res.data.user_data.length > 0) {
          setSearchEmpty(false);

          setSearchList(res.data.user_data);
        }
      } else {
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/v1/check_eligibility_users?search=${searchQuery}&page=${pageNo}&rows_per_page=${rowsPerPage}&sort_by=${sortType}&order=${sortBy}`,
          options
        );
        setSearchPages(res.data.total_page_count);
        setSearchRows(res.data.total_records);
        // setList(res.data.user_details);
        if (res.data.user_data.length < 1) {
          setSearchEmpty(true);
        }
        if (res.data.user_data.length > 0) {
          setSearchEmpty(false);

          setSearchList(res.data.user_data);
        }
      }
      setImageLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    sessionStorage.removeItem("currentPage");
    const controller = new AbortController();
    if (searchQuery) {
      fetchSearchedUsers(controller, false);
      return;
    }
    fetchUsers(controller, false);

    return () => {
      controller.abort();
    };
  }, [pageNo, rowsPerPage, sortType, sortBy]);

  useEffect(() => {
    sessionStorage.removeItem("query");
    const controller = new AbortController();
    if (searchQuery !== "") {
      setPageNo(1);
      fetchSearchedUsers(controller, false);
      setList([]);
    }
    if (searchQuery === "") {
      fetchUsers(controller, false);
      setSearchList([]);
      setSearchEmpty(false);
    }
    return () => {
      controller.abort();
    };
  }, [searchQuery]);

  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);

  const displayedRows = list.length > 0 ? list : searchList;
  const noOfRows = list.length > 0 ? totalRows : searchRows;
  const noOfPages = list.length > 0 ? totalPages : searchPages;

  function formatToIndianRupees(num) {
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }

  const handleClickOutside = (event) => {
    if (sortRef.current && sortRef.current.contains(event.target)) {
      return;
    }
    if (sortDivRef.current && !sortDivRef.current.contains(event.target)) {
      setOpenSorting(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[20px] pt-[16px] transition-all ease-in-out duration-100`}
    >
      <div className="mt-4 rounded-lg bg-white mb-4 p-4">
        <p className="text-[#262626] text-xl font-semibold">Eligible Users</p>
      </div>
      <div className=" bg-white px-4 flex flex-col justify-between pt-2 rounded-t-lg">
        <EligibleTopBar
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showButton={true}
          downloadPageWord="assets"
        />
      </div>
      {!showUserDetails ? (
        <>
          <div className="pt-3 w-full bg-white">
            {imageLoading && (
              <div className="w-full h-[calc(100vh-245px)] flex items-center justify-center">
                <ImageLoading />
              </div>
            )}
            {!imageLoading && (
              <table className="w-full box-border h-full flex flex-col">
                <thead className="text-sm font-semibold h-full">
                  <tr className="w-full flex items-center pb-1 relative">
                    <th
                      className={`text-left w-[19%] text-sm font-semibold pl-5`}
                    >
                      Phone Number
                    </th>
                    <th className={`text-left w-[15%] text-sm font-semibold`}>
                      PAN Number
                    </th>
                    <th className="text-left pl-14 w-[12%] text-sm font-semibold">
                      Timestamp
                    </th>
                    <th className="text-right w-[15%] text-sm font-semibold flex flex-row justify-end items-center">
                      <div
                        className="flex flex-row items-center gap-1 cursor-pointer"
                        ref={sortRef}
                        onClick={() => {
                          if (sortTypeTemp === "demat_amount") {
                            setOpenSorting(!openSorting);
                          } else {
                            setOpenSorting(true);
                            setSortTypeTemp("demat_amount");
                            setSortType("");
                            setSortBy("");
                          }
                        }}
                      >
                        Demat{" "}
                        {sortType === "demat_amount" && sortBy === "asc" ? (
                          <img src={asc} alt="demat" className="" />
                        ) : sortType === "demat_amount" && sortBy === "desc" ? (
                          <img src={desc} alt="demat" className="" />
                        ) : (
                          <img src={all} alt="demat" className="" />
                        )}
                      </div>
                      {/* <RiExpandUpDownFill
                        className="cursor-pointer"
                        onClick={() => {
                          if (sortType === "demat_amount") {
                            setOpenSorting(!openSorting);
                          } else {
                            setOpenSorting(true);
                            setSortType("demat_amount");
                          }
                        }}
                      /> */}
                    </th>
                    <th className="text-right w-[19%] text-sm font-semibold flex flex-row justify-end items-center">
                      <div
                        className="flex flex-row items-center gap-1 cursor-pointer"
                        ref={sortRef}
                        onClick={() => {
                          if (sortTypeTemp === "un_approved_amount") {
                            setOpenSorting(!openSorting);
                          } else {
                            setOpenSorting(true);
                            setSortTypeTemp("un_approved_amount");
                            setSortType("");
                            // setSortType("un_approved_amount");
                            setSortBy("");
                          }
                        }}
                      >
                        Unapproved{" "}
                        {sortType === "un_approved_amount" &&
                        sortBy === "asc" ? (
                          <img src={asc} alt="unapproved" className="" />
                        ) : sortType === "un_approved_amount" &&
                          sortBy === "desc" ? (
                          <img src={desc} alt="unapproved" className="" />
                        ) : (
                          <img src={all} alt="unapproved" className="" />
                        )}
                      </div>
                      {/* <RiExpandUpDownFill
                        className="cursor-pointer"
                        onClick={() => {
                          if (sortType === "un_approved_amount") {
                            setOpenSorting(!openSorting);
                          } else {
                            setOpenSorting(true);
                            setSortType("un_approved_amount");
                          }
                        }}
                      /> */}
                    </th>
                    <th className="text-right w-[18%] text-sm font-semibold flex flex-row justify-end items-center">
                      <div
                        className="flex flex-row items-center gap-1 cursor-pointer"
                        ref={sortRef}
                        onClick={() => {
                          if (sortTypeTemp === "eligibility_limit") {
                            setOpenSorting(!openSorting);
                          } else {
                            setOpenSorting(true);
                            setSortTypeTemp("eligibility_limit");
                            setSortType("");
                            // setSortType("eligibility_limit");
                            setSortBy("");
                          }
                        }}
                      >
                        Credit Limit{" "}
                        {sortType === "eligibility_limit" &&
                        sortBy === "asc" ? (
                          <img src={asc} alt="credit" className="" />
                        ) : sortType === "eligibility_limit" &&
                          sortBy === "desc" ? (
                          <img src={desc} alt="credit" className="" />
                        ) : (
                          <img src={all} alt="credit" className="" />
                        )}
                      </div>
                      {/* <RiExpandUpDownFill
                        className="cursor-pointer"
                        onClick={() => {
                          if (sortType === "eligibility_limit") {
                            setOpenSorting(!openSorting);
                          } else {
                            setOpenSorting(true);
                            setSortType("eligibility_limit");
                          }
                        }}
                      /> */}
                    </th>
                    {openSorting && (
                      <div
                        ref={sortDivRef}
                        className={`w-[162px] px-2 rounded-lg absolute top-6 z-10 bg-white text-xs font-medium shadow-md py-2 ${
                          sortTypeTemp === "eligibility_limit"
                            ? "right-[2%]"
                            : sortTypeTemp === "un_approved_amount"
                            ? "right-[20%]"
                            : "right-[39%]"
                        }`}
                      >
                        <div
                          className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
                            sortBy === "asc" && "bg-[#A0FF77]"
                          }`}
                          onClick={() => {
                            setSortType(sortTypeTemp);
                            setSortBy("asc");
                            setOpenSorting(false);
                          }}
                        >
                          <CgArrowUp size={"15px"} /> Sort Ascending
                        </div>
                        <div
                          className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] mt-2 pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
                            sortBy === "desc" && "bg-[#A0FF77]"
                          }`}
                          onClick={() => {
                            setSortType(sortTypeTemp);
                            setSortBy("desc");
                            setOpenSorting(false);
                          }}
                        >
                          <CgArrowDown size={"15px"} /> Sort Descending
                        </div>
                        {sortBy && (
                          <div className="flex flex-row justify-center items-center w-full">
                            <button
                              type="button"
                              className="py-[3px] px-2 rounded w-[73px] h-6 font-medium  text-[#00394d] border border-[#00394d] mt-3 flex flex-row justify-center items-center gap-2"
                              onClick={() => {
                                setSortBy("");
                                setSortType("");
                                setSortType("");
                                setOpenSorting(false);
                              }}
                            >
                              <TbFilterX size={"15px"} /> Clear
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </tr>
                </thead>
                <tbody
                  className={`overflow-auto max-h-[calc(100vh-280px)] ${
                    displayedRows.length === 0 ||
                    (searchEmpty && searchQuery !== "")
                      ? "h-[calc(100vh-245px)]"
                      : ""
                  }`}
                >
                  {searchEmpty && searchQuery !== "" ? (
                    <>
                      <NoSearchitems />
                    </>
                  ) : (
                    <>
                      {displayedRows.length ? (
                        <>
                          {displayedRows?.map((i, index) => (
                            <tr
                              onClick={() => {
                                navigate(`/eligibleusers/${i.uuid}`);
                              }}
                              key={index}
                              className={`${
                                index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                              }  text-xs font-medium w-full flex items-center hover:bg-[#E6EBED] ${
                                userType === "distributors"
                                  ? ""
                                  : "cursor-pointer"
                              }`}
                            >
                              <td
                                className={`pl-5 pt-3 pb-2 text-left w-[19%] text-xs font-medium`}
                              >
                                {i.phone ? i.phone : "--"}
                              </td>
                              <td
                                className={`text-left w-[15%] text-xs font-medium`}
                              >
                                {i.pan_number ? i.pan_number : "--"}
                              </td>
                              <td className="text-left pl-14 w-[12%] text-xs font-medium">
                                {i.user_created ? i.user_created : "--"}
                              </td>
                              <td
                                className={`text-right w-[15%] text-xs font-medium`}
                              >
                                {i?.portfolio?.demat_amount === null
                                  ? "--"
                                  : formatToIndianRupees(
                                      i?.portfolio?.demat_amount
                                    )}
                              </td>
                              <td
                                className={`text-right w-[19%] text-xs font-medium`}
                              >
                                {i?.portfolio?.un_approved_amount === null
                                  ? "--"
                                  : formatToIndianRupees(
                                      i?.portfolio?.un_approved_amount
                                    )}
                              </td>
                              <td
                                className={`text-right w-[18%] text-xs font-medium text-[#0BA300]`}
                              >
                                {i?.portfolio?.eligibility_limit === null
                                  ? "--"
                                  : formatToIndianRupees(
                                      i?.portfolio?.eligibility_limit
                                    )}
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <>
                          <NoDataFound insidePage={false} />
                        </>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            )}
          </div>
          <TableFooter
            totalPages={noOfPages}
            totalRows={noOfRows}
            rowsPerPage={rowsPerPage}
            startIndex={startIndex}
            endIndex={endIndex}
            setStartIndex={setStartIndex}
            setEndIndex={setEndIndex}
            setPageNo={setPageNo}
            pageNo={pageNo}
            setRowsPerPage={setRowsPerPage}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default EligibleUsers;
